import React from 'react';
import { cssTransition, ToastContainer } from 'react-toastify';
import AlertIcon from '@tradera/blueprint/theme/icons2/alert.svg?jsx';
import CheckIcon from '@tradera/blueprint/theme/icons2/check.svg?jsx';
import InfoIcon from '@tradera/blueprint/theme/icons2/info.svg?jsx';
import HotIcon from '@tradera/blueprint/theme/icons2/hot.svg?jsx';
import CloseIcon from '@tradera/blueprint/theme/icons2/close.svg?jsx';

import 'react-toastify/dist/ReactToastify.css';

var SlideFade = /*#__PURE__*/ cssTransition({
    enter: 'Toastify--animate Toastify__slideFade-enter',
    exit: 'Toastify--animate Toastify__slideFade-exit'
});

const options = {
    className: 'bp',
    transition: SlideFade,
    hideProgressBar: true,
    theme: 'colored',
    closeOnClick: false,
    draggablePercent: 40,
    autoClose: 5000,
    pauseOnFocusLoss: false,
    icon: ({ type }) =>
        ({
            // default, - no icon.
            info: <InfoIcon className="icon" />,
            success: <CheckIcon className="icon" />,
            hot: <HotIcon className="icon" />,
            warning: <AlertIcon className="icon" />,
            error: <AlertIcon className="icon" />
        }[type]),
    closeButton({ closeToast }) {
        return (
            <div className="d-flex my-1">
                <CloseIcon
                    style={{ marginTop: 3 }}
                    className="icon icon-xs"
                    onClick={closeToast}
                />
            </div>
        );
    }
};

export const TraderaToastContainer = () => {
    return <ToastContainer {...options} />;
};
